import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CTASection({ title, subtitle, locationName }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-navy via-[#0f2847] to-brand-navy py-20" data-testid="cta-section">
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-brand-pink/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-brand-blue/20 rounded-full blur-3xl" />
      {/* Mascot accent — subtle floating flamingo on right side */}
      <img
        src="/flamingo.png"
        alt=""
        aria-hidden="true"
        className="hidden md:block absolute right-8 lg:right-16 top-1/2 -translate-y-1/2 w-32 lg:w-44 opacity-90 drop-shadow-2xl rotate-12 pointer-events-none select-none"
        loading="lazy"
        data-testid="cta-mascot"
      />
      <div className="section-container relative">
        <div className="max-w-3xl">
          <div className="overline text-brand-pink mb-4">Ready to get started?</div>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-6 leading-tight">
            {title || "Crystal Clear Pool, Zero Hassle."}
          </h2>
          <p className="text-lg text-slate-300 mb-8 leading-relaxed">
            {subtitle ||
              `Get a free quote today${locationName ? ` for pool service in ${locationName}` : ""}. Family-owned, 20+ years on the Treasure Coast, and every visit backed by detailed before/after reporting.`}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact" className="btn-primary" data-testid="cta-free-estimate">
              Get Free Estimate <ArrowRight className="w-4 h-4" />
            </Link>
            <a
              href="tel:7722890405"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur text-white border-2 border-white/20 hover:bg-white hover:text-brand-navy font-bold rounded-lg px-6 py-3 transition-all"
              data-testid="cta-phone"
            >
              <Phone className="w-4 h-4" /> 772-289-0405
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
